<input-button-popup 
        [tabindex]="tabindex"
        [label]="config.COLUMNDESC"
        [placeholder]="config.PLACEHOLDER"  
        type="text" 
        [icon]="action_icon"
        [controle]="group.get(config.COLUMNNAME)"
        [required]="config.ISIDENTITY ==1? false : config.ISREQUIRED == 1"
        (result)="formSubmitted($event)"
        [disabled]="disableAction"
        [data]="group"
        [validation]="validation"
        [widthPopUp]="widthPopUp"
        [nz-tooltip]="toolTip"
        [component]="component"
        (onEditing)="editing()"
        (onDestroy)="canceling($event)"
        (blur)="bluring($event)">
        <span suffix tabindex="-1" class="tem-field-suffix">
            <button nz-button nzType="text" nzSize="small" (click)="actionClick($event)" nz-tooltip="Apagar dados." [disabled]="disableAction" tabindex="-1">
                <nz-icon nzType="close"></nz-icon>
            </button>
            <button nz-button nzType="text" nzSize="small" *ngIf="toolTipText!=null" [tooltip]="toolTipText">
                <nz-icon nzType="question-circle"></nz-icon>
            </button>
            <form-field-properties [information]="config" [entityDesc]="entityDesc" [entityName]="entityName" *ngIf="canConfig" [row]="row"></form-field-properties>
        </span>
</input-button-popup>

